<template>
  <div class="levelTag" v-if="level>0">
    V{{level}}+专享
  </div>
</template>
<script>


export default {
  name: "LevelTag",
  components: { },
  props: {
     level:{
       type:Number,
       default:1
     },
    }
  };
</script>


<style lang="stylus" scoped>
  .levelTag
      position relative
      background: #FBD99E;
      font-size: .18rem;
      padding .02rem .04rem
      color: #804919;
      border-radius 0.02rem
      pointer-events: none; //点击穿透
      border-radius: 0.04rem 0 0.16rem 0;
</style>
